module.exports = __webpack_public_path__ + "static/media/Sidonian_canaanite-phoenician_icon.f6c161bb.png";